/* Designplåt Produktkonfigurator – v5 (theme-asset, Shadow DOM, fungerar på mobil).
   Monteras i <div id="dp-konfigurator" data-delar=... data-kub=... ...>.
   Three.js laddas via esm.sh (dedupar three-instansen åt addons → ingen importmap behövs). */
import * as THREE from 'https://esm.sh/three@0.160.0';
import { OrbitControls } from 'https://esm.sh/three@0.160.0/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'https://esm.sh/three@0.160.0/examples/jsm/loaders/GLTFLoader.js';

const mount = document.getElementById('dp-konfigurator');
if (mount && !mount.dataset.dpkInit) {
  mount.dataset.dpkInit = '1';
  const URLS = {
    delar:    mount.dataset.delar,
    kub:      mount.dataset.kub,
    beslag:   mount.dataset.beslag,
    vinkel:   mount.dataset.vinkel,
    logo:     mount.dataset.logo,
    forstark: mount.dataset.forstark,
  };

  const root = mount.attachShadow({ mode: 'open' });
  root.innerHTML = `
<style>
  :host{ display:block; }
  *{ box-sizing:border-box; margin:0; padding:0; }
  .dpk-app{
    --ink:#1d1d1f; --muted:#6e6e73; --line:#e3e3e0; --bg:#fafaf8; --panel:#ffffff;
    display:flex; height:600px; max-height:82vh;
    border:1px solid var(--line); border-radius:14px; overflow:hidden;
    background:var(--bg); color:var(--ink);
    font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;
  }
  #viewport{ flex:1; position:relative; min-width:0; overflow:hidden; }
  #viewport canvas{ display:block; touch-action:none; }
  #reset{ position:absolute; top:16px; right:16px; background:#fff; color:#c0392b; border:1px solid var(--line); border-radius:999px; padding:7px 18px; font-size:14px; cursor:pointer; box-shadow:0 1px 4px rgba(0,0,0,.06); }
  #reset:hover{ background:#f6f6f4; }
  #brand{ position:absolute; top:16px; left:20px; font-size:15px; letter-spacing:.12em; font-weight:600; color:#3a3a3c; text-transform:uppercase; }
  #brand span{ color:#9a9a9e; font-weight:400; letter-spacing:0; text-transform:none; display:block; font-size:12px; margin-top:2px; }
  #panel{ width:360px; background:var(--panel); border-left:1px solid var(--line); padding:24px 26px; overflow-y:auto; }
  .buyrow{ display:flex; align-items:center; gap:12px; margin-bottom:6px; }
  #price{ font-size:26px; font-weight:700; flex:1; white-space:nowrap; }
  #price.offert{ font-size:18px; color:var(--muted); font-weight:600; }
  #qty{ width:58px; padding:9px 6px; border:1px solid var(--line); border-radius:10px; font-size:15px; text-align:center; }
  #buy{ background:#1d1d1f; color:#fff; border:none; border-radius:999px; padding:13px 22px; font-size:15px; font-weight:600; cursor:pointer; white-space:nowrap; }
  #buy:hover{ background:#000; }
  #prodname{ font-size:13px; color:var(--muted); margin-bottom:4px; }
  #moduler{ font-size:12px; color:#9a9a9e; margin-bottom:16px; }
  .field{ margin-top:16px; }
  .field label{ display:block; font-size:13.5px; color:#3a3a3c; margin-bottom:7px; }
  select{ width:100%; appearance:none; -webkit-appearance:none; padding:12px 14px; font-size:15px; border:1px solid var(--line); border-radius:12px; background:#fff url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8"><path d="M1 1l5 5 5-5" stroke="%236e6e73" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>') no-repeat right 14px center; cursor:pointer; color:var(--ink); }
  select:disabled{ color:#b0b0b4; background-color:#f7f7f5; cursor:default; }
  .seg{ display:flex; border:1px solid var(--line); border-radius:12px; overflow:hidden; }
  .seg button{ flex:1; padding:12px 0; font-size:15px; background:#fff; border:none; cursor:pointer; color:var(--muted); }
  .seg button.on{ background:#f2f2f0; color:var(--ink); font-weight:600; box-shadow:inset 0 0 0 1.5px #d8d8d4; border-radius:11px; }
  .seg button:disabled{ color:#c9c9cd; cursor:default; }
  .formikon{ display:inline-block; width:22px; height:14px; margin-right:7px; vertical-align:-2px; }
  .swatchrow{ display:flex; align-items:center; gap:10px; }
  .swatch{ width:20px; height:20px; border-radius:5px; border:1px solid rgba(0,0,0,.15); flex:none; }
  .colorselectwrap{ position:relative; flex:1; }
  .note{ margin-top:22px; padding:12px 14px; background:#f6f6f3; border-radius:12px; font-size:12.5px; line-height:1.5; color:var(--muted); }
  #toast{ position:fixed; left:50%; bottom:28px; transform:translateX(-50%) translateY(20px); background:#1d1d1f; color:#fff; padding:13px 20px; border-radius:14px; font-size:14px; opacity:0; pointer-events:none; transition:all .3s; max-width:90%; text-align:center; z-index:9999; }
  #toast.show{ opacity:1; transform:translateX(-50%) translateY(0); }
  @media (max-width:760px){
    .dpk-app{ flex-direction:column; height:auto; max-height:none; }
    #viewport{ height:56vh; min-height:300px; flex:none; width:100%; }
    #panel{ width:100%; border-left:none; border-top:1px solid var(--line); }
    .buyrow{ flex-wrap:wrap; }
    #price{ flex:1 1 100%; }
    #buy{ flex:1; }
  }
</style>
<div class="dpk-app">
  <div id="viewport">
    <div id="brand">Designplåt<span>Produktkonfigurator</span></div>
    <button id="reset">Återställ</button>
  </div>
  <div id="panel">
    <div class="buyrow">
      <div id="price">2 495 kr</div>
      <input id="qty" type="number" min="1" value="1" autocomplete="off">
      <button id="buy">Lägg i varukorg</button>
    </div>
    <div id="prodname">Planteringslåda Kub 40x40x60 · Svart / Utan hjul</div>
    <div id="moduler"></div>

    <div class="field">
      <label>Form</label>
      <div class="seg" id="formseg">
        <button data-v="rak" class="on"><svg class="formikon" viewBox="0 0 22 14"><rect x="1" y="5" width="20" height="5" rx="1" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>Rak</button>
        <button data-v="vinkel"><svg class="formikon" viewBox="0 0 22 14"><path d="M1 1 h5 v7 h15 v5 H1 Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>Vinkel</button>
      </div>
    </div>

    <div class="field">
      <label>Färg</label>
      <div class="swatchrow">
        <div class="swatch" id="swatch" style="background:#1d1d1f"></div>
        <div class="colorselectwrap">
          <select id="farg" autocomplete="off">
            <option value="svart">Svart</option>
            <option value="beige">Beige</option>
            <option value="corten">Corten</option>
          </select>
        </div>
      </div>
    </div>

    <div class="field">
      <label>Hjul</label>
      <div class="seg" id="hjulseg">
        <button data-v="ja">Ja</button>
        <button data-v="nej" class="on">Nej</button>
      </div>
    </div>

    <div class="field" id="falt-langd">
      <label>Längd (cm)</label>
      <select id="langd" autocomplete="off"></select>
    </div>

    <div class="field" id="falt-l1" style="display:none">
      <label>Storlek (cm)</label>
      <select id="l1" autocomplete="off"></select>
    </div>

    <div class="field" id="falt-l2" style="display:none">
      <label>Längd 2 (cm)</label>
      <select id="l2" autocomplete="off"></select>
    </div>

    <div class="field">
      <label>Bredd (cm)</label>
      <select id="bredd" autocomplete="off"></select>
    </div>

    <div class="field">
      <label>Höjd (cm)</label>
      <select id="hojd"><option>60</option></select>
    </div>

    <div class="note" id="bottennote">Planteringslådor (bredd 40 samt kub) levereras med botten. Odlingslådor (bredd 80/120) är öppna i botten för odling direkt i marken.</div>
    <div class="note">Byggd på moduldelarna från SketchUp – väggar 40/80/120, förlängningsbeslag och bottenplattor monteras precis som den riktiga produkten. Priser från designplat.se.</div>
  </div>
</div>
<div id="toast"></div>`;

  const el = id => root.querySelector('#' + id);
  const qsa = sel => root.querySelectorAll(sel);

  /* ---------- Produkt- och prisdata (från Shopify, juni 2026) ---------- */
  const PRODUKTER = {
    '40x40'  : {namn:'Planteringslåda Kub 40x40x60',  handle:'planteringslada-kub-40x40x60',  pris:2495,  prisHjul:2845,  hjul:true,  botten:true, v:{svart:[56712012661001,56592479027465], beige:[56712012693769,56592479060233], corten:[56712012726537,56592479093001]}},
    '80x80'  : {namn:'Planteringslåda Kub 80x80x60',  handle:'planteringslada-kub-80x80x60',  pris:4495,  prisHjul:5195,  hjul:true,  botten:true, v:{svart:[56712023277833,56592568353033], beige:[56712023343369,56592568451337], corten:[56712023310601,56592568418569]}},
    '80x40'  : {namn:'Planteringslåda Flex 80x40x60', handle:'planteringslada-flex-80x40x60', pris:3495,  prisHjul:3845,  hjul:true,  botten:true, v:{svart:[56593164828937,56712709406985], beige:[56593164861705,56712709439753], corten:[56593164894473,56712709472521]}},
    '120x40' : {namn:'Planteringslåda Flex 120x40x60',handle:'planteringslada-flex-120x40x60',pris:3995,  prisHjul:4495,  hjul:true,  botten:true, v:{svart:[56593237377289,56712716321033], beige:[56593237475593,56712716386569], corten:[56593237442825,56712716353801]}},
    '160x40' : {namn:'Planteringslåda Flex 160x40x60',handle:'planteringslada-flex-160x40x60',pris:5995,  prisHjul:6695,  hjul:true,  botten:true, v:{svart:[56593372971273,56712864432393], beige:[56593373004041,56712864465161], corten:[56593373036809,56712864497929]}},
    '200x40' : {namn:'Planteringslåda Flex 200x40x60',handle:'planteringslada-flex-200x40x60',pris:6995,  prisHjul:7845,  hjul:true,  botten:true, v:{svart:[56593590550793,56713089483017], beige:[56593590649097,56713089548553], corten:[56593590616329,56713089515785]}},
    '240x40' : {namn:'Planteringslåda Flex 240x40x60',handle:'planteringslada-flex-240x40x60',pris:7995,  prisHjul:8995,  hjul:true,  botten:true, v:{svart:[56594167693577,56713230352649], beige:[56594167726345,56713230385417], corten:[56594167759113,56713230418185]}},
    '360x40' : {namn:'Planteringslåda Flex 360x40x60',handle:'planteringslada-flex-360x40x60',pris:10995, prisHjul:12495, hjul:true,  botten:true, v:{svart:[56594230771977,56713239789833], beige:[56594230804745,56713239822601], corten:[56594230837513,56713239855369]}},
    '480x40' : {namn:'Planteringslåda Flex 480x40x60',handle:'planteringslada-flex-480x40x60',pris:14995, prisHjul:16995, hjul:true,  botten:true, v:{svart:[56594286838025,56713245655305], beige:[56594286870793,56713245688073], corten:[56594286903561,56713245720841]}},
    '600x40' : {namn:'Planteringslåda Flex 600x40x60',handle:'planteringslada-flex-600x40x60',pris:17995, prisHjul:20490, hjul:true,  botten:true, v:{svart:[56594327470345,56713253323017], beige:[56594327503113,56713253355785], corten:[56594327535881,56713253388553]}},
    '120x80' : {namn:'Odlingslåda 120x80x60',         handle:'odlingslada-120x80x60',         pris:3495,  prisHjul:null,  hjul:false, botten:false, v:{svart:[56592660726025,null], beige:[56592660824329,null], corten:[56592660791561,null]}},
    '240x80' : {namn:'Odlingslåda 240x80x60',         handle:'odlindslada-240x80x60',         pris:5995,  prisHjul:null,  hjul:false, botten:false, v:{svart:[56592838852873,null], beige:[56592838885641,null], corten:[56592838918409,null]}},
    '120x120': {namn:'Odlingslåda 120x120x60',        handle:'odlingslada-120x120x60',        pris:3995,  prisHjul:null,  hjul:false, botten:false, v:{svart:[56592911827209,null], beige:[56592911859977,null], corten:[56592911892745,null]}},
  };
  /* Vinkellådor (L-form) – två ben som delar hörn, bredd 40 */
  const PRODUKTER_VINKEL = {
    '120x120': {namn:'Planteringslåda Vinkel 120x120x40x60', handle:'planteringslada-vinkel-120x120x40x60', pris:6995,  prisHjul:7845,  hjul:true, botten:true, v:{svart:[56593447387401,56713274392841], beige:[56593447485705,56713274458377], corten:[56593447452937,56713274425609]}},
    '240x240': {namn:'Planteringslåda Vinkel 240x240x40x60', handle:'planteringslada-vinkel-240x240x40x60', pris:12995, prisHjul:14845, hjul:true, botten:true, v:{svart:[56594014011657,56713277112585], beige:[56594014044425,56713277145353], corten:[56594014077193,56713277178121]}},
  };
  const LANGDER = [40,80,120,160,200,240,360,480,600];
  const VINKEL_LANGDER = [120,240];  // endast de två vinkelprodukterna (lika sidor)
  const FARGNAMN = {svart:'Svart', beige:'Beige', corten:'Corten'};

  const state = {form:'rak', langd:40, bredd:40, l1:120, l2:120, farg:'svart', hjul:false, qty:1};

  function nyckel(){
    if(state.form==='vinkel') return `${Math.max(state.l1,state.l2)}x${Math.min(state.l1,state.l2)}`;
    const L=Math.max(state.langd,state.bredd), B=Math.min(state.langd,state.bredd);
    return `${L}x${B}`;
  }
  function produkt(){
    return state.form==='vinkel' ? PRODUKTER_VINKEL[nyckel()] || null : PRODUKTER[nyckel()];
  }
  function breddAlternativ(L){ return [40,80,120].filter(B => PRODUKTER[`${Math.max(L,B)}x${Math.min(L,B)}`]); }

  /* Dela upp ett nominellt mått (mm) i moduler 1200/800/400 – som produkten byggs */
  function moduler(mm){
    if(mm === 1600) return [800, 800];
    const ut = [];
    while(mm >= 1600){ ut.push(1200); mm -= 1200; }
    if(mm === 1200) ut.push(1200);
    else if(mm === 800) ut.push(800);
    else if(mm === 400) ut.push(400);
    return ut.length ? ut : [400];
  }

  /* ---------- Three.js-scen ---------- */
  const viewport = el('viewport');
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf4f4f1);
  scene.fog = new THREE.Fog(0xf4f4f1, 12, 30);

  const camera = new THREE.PerspectiveCamera(32, 1, 0.05, 100);
  const renderer = new THREE.WebGLRenderer({antialias:true});
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  viewport.appendChild(renderer.domElement);

  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.maxPolarAngle = Math.PI/2 - 0.03;
  controls.minDistance = 0.6;

  scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d4cc, 1.1));
  const sun = new THREE.DirectionalLight(0xffffff, 2.0);
  sun.position.set(3, 5, 2.5);
  scene.add(sun);
  const fill = new THREE.DirectionalLight(0xffffff, 0.5);
  fill.position.set(-4, 2, -3);
  scene.add(fill);

  /* Mjuk kontaktskugga – ritas om för varje storlek/form så den följer lådan */
  const shadowCanvas = document.createElement('canvas');
  shadowCanvas.width = 1024; shadowCanvas.height = 1024;
  const shadowTex = new THREE.CanvasTexture(shadowCanvas);
  const shadowPlane = new THREE.Mesh(
    new THREE.PlaneGeometry(1,1),
    new THREE.MeshBasicMaterial({map:shadowTex, transparent:true, depthWrite:false})
  );
  shadowPlane.rotation.x = -Math.PI/2;
  shadowPlane.position.y = 0.0015;
  shadowPlane.renderOrder = -1;
  scene.add(shadowPlane);

  function updateShadow(rects, totW, totD, cx, cz){
    const marg = 0.22;
    const W = totW + 2*marg, D = totD + 2*marg;
    const g = shadowCanvas.getContext('2d');
    g.clearRect(0,0,1024,1024);
    const px = 1024/W, pz = 1024/D;
    const rita = (inset, blur, alpha) => {
      g.filter = `blur(${blur}px)`;
      g.fillStyle = `rgba(20,18,16,${alpha})`;
      for(const r of rects){
        const x0 = (r.x - cx + totW/2 + marg + inset)*px;
        const z0 = (marg + totD - (r.y - cz + totD/2) - r.d + inset)*pz;
        g.beginPath();
        g.roundRect(x0, z0, (r.w - 2*inset)*px, (r.d - 2*inset)*pz, 14);
        g.fill();
      }
    };
    rita(0, 46, 0.42);
    rita(0.06, 18, 0.30);
    g.filter = 'none';
    shadowTex.needsUpdate = true;
    shadowPlane.scale.set(W, D, 1);
  }

  /* ---------- Material ---------- */
  function cortenTexture(){
    const c = document.createElement('canvas'); c.width = c.height = 512;
    const g = c.getContext('2d');
    g.fillStyle = '#8a4a32'; g.fillRect(0,0,512,512);
    const pal = ['#7d4427','#94553a','#a2603f','#6e3b22','#8f4e2e','#9c5c3c'];
    for(let i=0;i<5200;i++){
      g.fillStyle = pal[(Math.random()*pal.length)|0];
      g.globalAlpha = 0.05 + Math.random()*0.16;
      const s = 1 + Math.random()*7;
      g.fillRect(Math.random()*512, Math.random()*512, s, s*(0.5+Math.random()));
    }
    g.globalAlpha = 1;
    const t = new THREE.CanvasTexture(c);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.colorSpace = THREE.SRGBColorSpace;
    return t;
  }
  const MATERIAL = {
    svart : new THREE.MeshStandardMaterial({color:0x55555a, roughness:0.62, metalness:0.3, side:THREE.DoubleSide}),
    beige : new THREE.MeshStandardMaterial({color:0xd0c2a0, roughness:0.55, metalness:0.25, side:THREE.DoubleSide}),
    corten: new THREE.MeshStandardMaterial({map:cortenTexture(), roughness:0.88, metalness:0.12, side:THREE.DoubleSide}),
  };
  const SWATCHFARG = {svart:'#55555a', beige:'#d0c2a0', corten:'#8a4a32'};
  const hjulMat = new THREE.MeshStandardMaterial({color:0x222224, roughness:0.85, metalness:0.1});
  const rostfriMat = new THREE.MeshStandardMaterial({color:0xc9cbce, roughness:0.34, metalness:0.5, side:THREE.DoubleSide});
  const logoSvartMat = new THREE.MeshStandardMaterial({color:0x141416, roughness:0.5, metalness:0.2, side:THREE.DoubleSide});

  /* ---------- Delbibliotek från SketchUp ---------- */
  const assembly = new THREE.Group();
  assembly.rotation.x = -Math.PI/2;
  scene.add(assembly);
  const hjulGroup = new THREE.Group();
  scene.add(hjulGroup);
  const dimGroup = new THREE.Group();
  scene.add(dimGroup);

  const HJUL_H = 0.022;
  const PLAT = 0.02;
  const BOTTEN_H = 0.025;
  const PARTS = {};

  function stretchX(geo, delta){
    const g = geo.clone();
    g.computeBoundingBox();
    const min = g.boundingBox.min.x, max = g.boundingBox.max.x, m = 0.05;
    const a = min+m, b = max-m;
    const pos = g.attributes.position;
    for(let i=0;i<pos.count;i++){
      const x = pos.getX(i);
      let nx;
      if(x <= a) nx = x;
      else if(x >= b) nx = x + delta;
      else nx = a + (x-a)*((b-a+delta)/(b-a));
      pos.setX(i, nx);
    }
    pos.needsUpdate = true;
    g.computeBoundingBox(); g.computeBoundingSphere();
    g.translate(-g.boundingBox.min.x, 0, 0);
    return g;
  }

  function rot180(geo){
    const g = geo.clone();
    g.rotateZ(Math.PI);
    g.computeBoundingBox();
    g.translate(-g.boundingBox.min.x, -g.boundingBox.min.y, -g.boundingBox.min.z);
    return g;
  }

  function normalisera(geo){
    geo.computeBoundingBox();
    geo.translate(-geo.boundingBox.min.x, -geo.boundingBox.min.y, -geo.boundingBox.min.z);
    return geo;
  }

  const loader = new GLTFLoader();
  (async ()=>{
    try {
      const [delarG, beslagG, vinkelG, logoG, forstarkG, kubG] = await Promise.all([
        loader.loadAsync(URLS.delar), loader.loadAsync(URLS.beslag), loader.loadAsync(URLS.vinkel),
        loader.loadAsync(URLS.logo), loader.loadAsync(URLS.forstark), loader.loadAsync(URLS.kub)
      ]);
      const grab = (gltf, fn)=>{ gltf.scene.updateMatrixWorld(true); gltf.scene.traverse(o=>{ if(o.isMesh){ const g=o.geometry.clone(); g.applyMatrix4(o.matrixWorld); fn(o,g); } }); };
      grab(delarG, (o,g)=>{ PARTS[o.name]=g; });
      PARTS.botten400 = stretchX(PARTS.botten800, -0.4);
      PARTS.vagg400 = rot180(PARTS.vagg400);
      grab(beslagG, (o,g)=>{ PARTS.beslag = rot180(g); });
      for(const n of ['vagg1200','vagg800','vagg400','beslag','botten1200']) PARTS[n+'F'] = rot180(PARTS[n]);
      grab(vinkelG, (o,g)=>{ PARTS.vinkelbeslag = g; });
      grab(logoG, (o,g)=>{ PARTS[o.name]=g; });
      grab(forstarkG, (o,g)=>{ PARTS.forstark = g; });
      let lagst=null, lagstY=Infinity;
      grab(kubG, (o,g)=>{ g.computeBoundingBox(); if(g.boundingBox.max.y < lagstY){ lagstY=g.boundingBox.max.y; lagst=g; } });
      lagst.rotateX(Math.PI/2);
      PARTS.sluten400 = normalisera(lagst);
      PARTS.sluten800 = stretchX(PARTS.sluten400, 0.4);
      PARTS.sluten1200 = stretchX(PARTS.sluten400, 0.8);
      buildAll(); fitCamera(true);
    } catch(err){ console.error('GLB-laddning fel', err); }
  })();

  function vaggGeo(mod){ return mod===1200 ? PARTS.vagg1200 : mod===800 ? PARTS.vagg800 : PARTS.vagg400; }
  function bottenGeo(mod){ return mod===1200 ? PARTS.botten1200 : mod===800 ? PARTS.botten800 : PARTS.botten400; }

  function addPart(geo, mat, x, y, z, rotZ=0){
    const m = new THREE.Mesh(geo, mat);
    m.rotation.z = rotZ;
    m.position.set(x, y, z);
    assembly.add(m);
    return m;
  }

  const VAGG_H = 0.575;
  function placeBeslag(geo, mat, x, y, rotZ){
    const harBotten = produkt() && produkt().botten;
    const m = addPart(geo, mat, x, y, harBotten ? -BOTTEN_H : 0, rotZ);
    if(!harBotten) m.scale.z = VAGG_H / 0.6;
    return m;
  }
  function vaggRad(mat, mm, x0, y0, flip=false, rev=false){
    const s = flip ? 'F' : '';
    let cum = 0;
    let mods = moduler(mm); if(rev) mods = mods.slice().reverse();
    mods.forEach((mod, i) => {
      addPart(PARTS['vagg'+mod+s], mat, x0 + cum, y0, 0);
      if(i > 0) placeBeslag(PARTS['beslag'+s], mat, x0 + cum - 0.023, y0, 0);
      cum += mod/1000;
    });
  }
  function vaggRadY(mat, mm, x0, y0, flip=false, rev=false){
    const s = flip ? 'F' : '';
    let cum = 0;
    let mods = moduler(mm); if(rev) mods = mods.slice().reverse();
    mods.forEach((mod, i) => {
      addPart(PARTS['vagg'+mod+s], mat, x0, y0 + cum, 0, Math.PI/2);
      if(i > 0) placeBeslag(PARTS['beslag'+s], mat, x0, y0 + cum - 0.023, Math.PI/2);
      cum += mod/1000;
    });
  }
  function plattGeo(mod, k, antal){
    if(antal === 1) return PARTS['sluten'+mod];
    if(k === antal-1){
      return mod===1200 ? PARTS.botten1200F : bottenGeo(mod);
    }
    return mod===1200 ? PARTS.botten1200 : PARTS['sluten'+mod];
  }
  function plattRad(mat, mm, x0, y0){
    const rad = moduler(mm);
    let cum = 0;
    rad.forEach((mod, k) => {
      addPart(plattGeo(mod, k, rad.length), mat, x0 + cum - (k>0 ? 0.004 : 0), y0, -BOTTEN_H);
      cum += mod/1000;
    });
  }
  function plattRadY(mat, mm, x0, y0){
    const rad = moduler(mm);
    let cum = 0;
    rad.forEach((mod, k) => {
      addPart(plattGeo(mod, k, rad.length), mat, x0, y0 + cum - (k>0 ? 0.004 : 0), -BOTTEN_H, Math.PI/2);
      cum += mod/1000;
    });
  }

  /* ---------- Rak låda ---------- */
  function buildRak(){
    const p = produkt();
    const mat = MATERIAL[state.farg];
    const Lmm = state.langd*10, Bmm = state.bredd*10;
    const L = Lmm/1000, B = Bmm/1000;

    vaggRad(mat, Lmm, 0, 0);
    vaggRad(mat, Lmm, 0, B - PLAT, true);
    vaggRadY(mat, Bmm, 0.017, 0.003, true);
    vaggRadY(mat, Bmm, L - 0.003, 0.003);

    if(p.botten){
      const rader = Math.round(Bmm/400);
      for(let r=0; r<rader; r++) plattRad(mat, Lmm, -0.003, r*0.4);
    }
    { let jc = 0; const segs = moduler(Lmm);
      segs.forEach((mod,i)=>{ jc += mod/1000; if(i < segs.length-1) addForstark(jc, 0, B, true); }); }
    addLogo();

    const lift = (state.hjul && p.hjul ? HJUL_H : 0) + (p.botten ? BOTTEN_H : 0);
    assembly.position.set(-(L/2) + 0.003, lift, B/2);
    return {rects:[{x:0, y:0, w:L, d:B}], totW:L, totD:B, cx:L/2, cz:B/2};
  }

  /* ---------- Vinkellåda (L-form) ---------- */
  function buildVinkel(){
    const p = produkt() || PRODUKTER_VINKEL['120x120'];
    const mat = MATERIAL[state.farg];
    const B = 0.4, Bmm = 400;
    const L1mm = state.l1*10, L2mm = state.l2*10;
    const L1 = L1mm/1000, L2 = L2mm/1000;

    vaggRad(mat, L1mm, 0, 0);
    vaggRadY(mat, L2mm, 0.017, 0.003, true);
    vaggRad(mat, L1mm - Bmm, B, B - PLAT, true, true);     // inre ben 1 – modulordning vänd: 80 närmast hörnet, 120 ytterst
    vaggRadY(mat, L2mm - Bmm, B - 0.003, B + 0.003, false, true); // inre ben 2 – samma vändning
    vaggRadY(mat, Bmm, L1 - 0.003, 0.003);
    vaggRad(mat, Bmm, 0.003, L2 - PLAT, true);

    addVinkelbeslag(mat, B - 0.01, B - 0.01);

    if(p.botten){
      plattRad(mat, L1mm, -0.003, 0);
      plattRadY(mat, L2mm - Bmm, 0.397, B - 0.003);
    }
    { let jc=0; const s1=moduler(L1mm); s1.forEach((mod,i)=>{ jc+=mod/1000; if(i<s1.length-1) addForstark(jc, 0, B, true); }); }
    { let jc=B; const s2=moduler(L2mm - Bmm).slice().reverse(); s2.forEach((mod,i)=>{ jc+=mod/1000; if(i<s2.length-1) addForstark(0, jc, B, false); }); }
    addLogo();

    const lift = (state.hjul && p.hjul ? HJUL_H : 0) + (p.botten ? BOTTEN_H : 0);
    assembly.position.set(-(L1/2) + 0.003, lift, L2/2);
    return {rects:[{x:0, y:0, w:L1, d:B}, {x:0, y:B, w:B, d:L2-B}], totW:L1, totD:L2, cx:L1/2, cz:L2/2};
  }

  let VBP = {rot:Math.PI, dx:0.0065, dy:0.0105};
  function addVinkelbeslag(mat, cornerX, cornerY){
    if(!PARTS.vinkelbeslag) return;
    const m = new THREE.Mesh(PARTS.vinkelbeslag, mat);
    m.position.set(cornerX + VBP.dx, cornerY + VBP.dy, -BOTTEN_H);
    m.rotation.z = VBP.rot;
    assembly.add(m);
  }

  function addLogo(){
    if(!PARTS.logoplatta) return;
    const g = new THREE.Group();
    g.add(new THREE.Mesh(PARTS.logoplatta, rostfriMat));
    const txt = new THREE.Mesh(PARTS.logotext, logoSvartMat);
    txt.position.y = -0.0004;
    g.add(txt);
    g.scale.set(0.75, 1, 0.75);
    g.position.set(0.012, -0.001, 0.536);
    assembly.add(g);
  }

  const FORSTARK_Z = (VAGG_H - 0.228) / 2;
  function addForstark(jx, jy, B, langsX){
    if(!PARTS.forstark) return;
    const m = new THREE.Mesh(PARTS.forstark, rostfriMat);
    if(langsX){
      m.position.set(jx - 0.01, jy, FORSTARK_Z);
      if(B > 0.4) m.scale.y = B/0.4;
    } else {
      m.rotation.z = -Math.PI/2;
      m.position.set(jx, jy + 0.01, FORSTARK_Z);
      if(B > 0.4) m.scale.x = B/0.4;
    }
    assembly.add(m);
  }

  function buildBox(){
    assembly.clear();
    if(!PARTS.vagg1200) return null;
    return state.form==='vinkel' ? buildVinkel() : buildRak();
  }

  /* ---------- Hjul ---------- */
  function applyHjul(){
    hjulGroup.clear();
    const p = produkt();
    if(!p || !(state.hjul && p.hjul) || !p.botten) return;
    const geo = new THREE.CylinderGeometry(0.023, 0.023, 0.02, 24);
    geo.rotateX(Math.PI/2);
    const positions = [];
    const platta = (x0, y0, lenX, lenY, mod, langsX, tf) => {
      const ix = Math.min(0.085, lenX/2 - 0.05), iy = Math.min(0.085, lenY/2 - 0.05);
      const c = [[x0+ix, y0+iy],[x0+lenX-ix, y0+iy],[x0+ix, y0+lenY-iy],[x0+lenX-ix, y0+lenY-iy]];
      if(mod === 1200){
        if(langsX) c.push([x0+lenX/2, y0+iy],[x0+lenX/2, y0+lenY-iy]);
        else       c.push([x0+ix, y0+lenY/2],[x0+lenX-ix, y0+lenY/2]);
      }
      for(const [x,y] of c) positions.push(tf(x,y));
    };

    if(state.form==='vinkel'){
      const L1 = state.l1/100, L2 = state.l2/100, B = 0.4;
      const tf = (x,y)=>[x - L1/2, L2/2 - y];
      let cum = 0;
      moduler(state.l1*10).forEach(mod => { const len=mod/1000; platta(cum, 0, len, B, mod, true, tf); cum += len; });
      cum = 0;
      moduler((state.l2*10) - 400).forEach(mod => { const len=mod/1000; platta(0, B+cum, B, len, mod, false, tf); cum += len; });
    } else {
      const L = state.langd/100, B = state.bredd/100, Lmm = state.langd*10, Bmm = state.bredd*10;
      const rader = Math.round(Bmm/400);
      const tf = (x,y)=>[x - L/2, y - B/2];
      for(let r=0; r<rader; r++){
        let cum = 0;
        moduler(Lmm).forEach(mod => { const len=mod/1000; platta(cum, r*0.4, len, 0.4, mod, true, tf); cum += len; });
      }
    }
    for(const [x,z] of positions){
      const w = new THREE.Mesh(geo, hjulMat);
      w.position.set(x, 0.023, z);
      hjulGroup.add(w);
    }
  }

  /* ---------- Måttlinjer ---------- */
  function textSprite(txt){
    const c = document.createElement('canvas'); c.width=256; c.height=96;
    const g = c.getContext('2d');
    g.font = '500 46px -apple-system, Helvetica, sans-serif';
    g.textAlign='center'; g.textBaseline='middle';
    g.fillStyle = '#3a3a3c';
    g.fillText(txt, 128, 48);
    const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace;
    const s = new THREE.Sprite(new THREE.SpriteMaterial({map:t, depthTest:false}));
    s.scale.set(0.34, 0.1275, 1);
    return s;
  }
  const dimMat = new THREE.LineBasicMaterial({color:0x8a8a8e});
  function dimLine(p1, p2, label){
    const dir = new THREE.Vector3().subVectors(p2,p1);
    const tick = new THREE.Vector3(-dir.z, 0, dir.x).normalize().multiplyScalar(0.025);
    const pts = [
      p1.clone().add(tick), p1.clone().sub(tick), p1, p2,
      p2.clone().add(tick), p2.clone().sub(tick),
    ];
    const g = new THREE.BufferGeometry().setFromPoints(pts);
    dimGroup.add(new THREE.LineSegments(g, dimMat));
    const mid = p1.clone().lerp(p2, 0.5); mid.y += 0.02;
    const spr = textSprite(label);
    spr.position.copy(mid);
    dimGroup.add(spr);
  }
  function applyDims(){
    dimGroup.clear();
    const y = 0.001, off = 0.14;
    if(state.form==='vinkel'){
      const L1 = state.l1/100, L2 = state.l2/100, B = 0.4;
      dimLine(new THREE.Vector3(-L1/2, y, L2/2+off), new THREE.Vector3(L1/2, y, L2/2+off), `${state.l1} cm`);
      dimLine(new THREE.Vector3(-L1/2-off, y, L2/2), new THREE.Vector3(-L1/2-off, y, -L2/2), `${state.l2} cm`);
      dimLine(new THREE.Vector3(L1/2+off, y, L2/2), new THREE.Vector3(L1/2+off, y, L2/2-B), `40 cm`);
    } else {
      const L = state.langd/100, B = state.bredd/100;
      dimLine(new THREE.Vector3(-L/2, y, B/2+off), new THREE.Vector3(L/2, y, B/2+off), `${state.langd} cm`);
      dimLine(new THREE.Vector3(-L/2-off, y, B/2), new THREE.Vector3(-L/2-off, y, -B/2), `${state.bredd} cm`);
    }
  }

  /* ---------- Kamera ---------- */
  function fitCamera(initial){
    const maxDim = state.form==='vinkel'
      ? Math.max(state.l1, state.l2)/100
      : Math.max(state.langd, state.bredd)/100;
    const dist = Math.max(maxDim, 0.6)*1.85 + 0.75;
    controls.target.set(0, 0.26, 0);
    if(initial){
      camera.position.set(dist*0.78, dist*0.62, dist*0.95);
    } else {
      const dir = camera.position.clone().sub(controls.target).normalize();
      camera.position.copy(controls.target).addScaledVector(dir, dist);
    }
  }

  /* ---------- UI-koppling ---------- */
  const fmt = n => n.toLocaleString('sv-SE') + ' kr';

  function modulText(){
    let runs;
    if(state.form==='vinkel'){
      runs = [state.l1*10, state.l2*10, state.l1*10-400, state.l2*10-400, 400, 400];
    } else {
      runs = [state.langd*10, state.langd*10, state.bredd*10, state.bredd*10];
    }
    const antal = {};
    let fogar = 0;
    runs.forEach(mm => {
      const m = moduler(mm);
      fogar += m.length - 1;
      m.forEach(x => antal[x] = (antal[x]||0)+1);
    });
    const delar = Object.keys(antal).sort((a,b)=>b-a).map(m => `${antal[m]}×${m/10}-vägg`);
    if(fogar > 0) delar.push(`${fogar} förlängningsbeslag`);
    let skarv;
    if(state.form==='vinkel') skarv = (moduler(state.l1*10).length-1) + (moduler(state.l2*10-400).length-1);
    else skarv = moduler(state.langd*10).length - 1;
    if(skarv > 0) delar.push(`${skarv} förstärkningsbeslag`);
    if(state.form==='vinkel') delar.push('1 vinkelbeslag');
    return 'Byggs av: ' + delar.join(' · ');
  }

  function applyUI(){
    const p = produkt();
    qsa('#formseg button').forEach(b=>{ b.classList.toggle('on', b.dataset.v===state.form); });
    el('falt-langd').style.display = state.form==='rak' ? '' : 'none';
    el('falt-l1').style.display = state.form==='vinkel' ? '' : 'none';
    el('falt-l2').style.display = 'none';
    el('langd').innerHTML = LANGDER.map(v=>`<option ${v===state.langd?'selected':''}>${v}</option>`).join('');
    el('l1').innerHTML = VINKEL_LANGDER.map(v=>`<option value="${v}" ${v===state.l1?'selected':''}>${v}×${v}</option>`).join('');
    if(state.form==='vinkel'){
      el('bredd').innerHTML = '<option>40</option>';
      el('bredd').disabled = true;
    } else {
      el('bredd').disabled = false;
      const balt = breddAlternativ(state.langd);
      el('bredd').innerHTML = balt.map(v=>`<option ${v===state.bredd?'selected':''}>${v}</option>`).join('');
    }
    const farHjul = p ? p.hjul : true;
    qsa('#hjulseg button').forEach(b=>{
      b.disabled = !farHjul;
      b.classList.toggle('on', (b.dataset.v==='ja') === (state.hjul && farHjul));
    });
    el('swatch').style.background = SWATCHFARG[state.farg];
    const priceEl = el('price');
    if(p){
      priceEl.classList.remove('offert');
      const pris = (state.hjul && p.hjul) ? p.prisHjul : p.pris;
      priceEl.textContent = fmt(pris * state.qty);
      el('prodname').textContent = `${p.namn} · ${FARGNAMN[state.farg]} / ${(state.hjul && p.hjul)?'Med hjul':'Utan hjul'}`;
      el('buy').textContent = 'Lägg i varukorg';
    } else {
      priceEl.classList.add('offert');
      priceEl.textContent = 'Pris på förfrågan';
      el('prodname').textContent = `Planteringslåda Vinkel ${state.l1}x${state.l2}x40x60 · ${FARGNAMN[state.farg]} – specialmått`;
      el('buy').textContent = 'Begär offert';
    }
    el('moduler').textContent = modulText();
  }

  function buildAll(){
    const fot = buildBox();
    applyHjul(); applyDims(); applyUI();
    if(fot) updateShadow(fot.rects, fot.totW, fot.totD, fot.cx, fot.cz);
  }

  qsa('#formseg button').forEach(b=>{
    b.addEventListener('click', ()=>{
      state.form = b.dataset.v;
      if(state.form==='vinkel'){ state.bredd = 40; }
      buildAll(); fitCamera(true);
    });
  });
  el('langd').addEventListener('change', e=>{
    state.langd = +e.target.value;
    const balt = breddAlternativ(state.langd);
    if(!balt.includes(state.bredd)) state.bredd = balt[0];
    if(produkt() && !produkt().hjul) state.hjul = false;
    buildAll(); fitCamera(false);
  });
  el('l1').addEventListener('change', e=>{ state.l1 = state.l2 = +e.target.value; buildAll(); fitCamera(false); });
  el('l2').addEventListener('change', e=>{ state.l2 = +e.target.value; buildAll(); fitCamera(false); });
  el('bredd').addEventListener('change', e=>{
    state.bredd = +e.target.value;
    if(produkt() && !produkt().hjul) state.hjul = false;
    buildAll(); fitCamera(false);
  });
  el('farg').addEventListener('change', e=>{ state.farg = e.target.value; buildAll(); });
  qsa('#hjulseg button').forEach(b=>{
    b.addEventListener('click', ()=>{ const p=produkt(); if(p && !p.hjul) return; state.hjul = b.dataset.v==='ja'; buildAll(); });
  });
  el('qty').addEventListener('change', e=>{ state.qty = Math.max(1, +e.target.value||1); e.target.value = state.qty; applyUI(); });
  el('reset').addEventListener('click', ()=>{
    Object.assign(state, {form:'rak', langd:40, bredd:40, l1:120, l2:120, farg:'svart', hjul:false, qty:1});
    el('qty').value = 1; el('farg').value = 'svart';
    buildAll(); fitCamera(true);
  });
  el('buy').addEventListener('click', ()=>{
    const p = produkt();
    const t = el('toast');
    const show = (h)=>{ t.innerHTML=h; t.classList.add('show'); clearTimeout(t._tm); t._tm=setTimeout(()=>t.classList.remove('show'),3500); };
    if(!p){ window.location.href = '/pages/kontaktpersoner'; return; }
    const varId = p.v[state.farg][(state.hjul && p.hjul) ? 1 : 0];
    if(!varId){ show('Varianten kunde inte hittas – kontakta oss.'); return; }
    const btn = el('buy'); btn.disabled = true;
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:varId, quantity:state.qty}]})})
      .then(r=>{ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(()=>{ window.location.href = '/cart'; })
      .catch(()=>{ btn.disabled=false; show('Något gick fel – försök igen.'); });
  });

  /* ---------- Render-loop + responsiv storlek ----------
     Canvasen synkas mot containern varje frame (three.js standardmönster) – robust mot
     layoutbyte (kolumn↔rad), mobil-rotation och temaomflöden där ResizeObserver kan missa. */
  const canvas = renderer.domElement;
  function resizeIfNeeded(){
    const w = viewport.clientWidth, h = viewport.clientHeight;
    if(!w || !h) return;
    if(canvas.clientWidth !== w || canvas.clientHeight !== h){
      camera.aspect = w/h; camera.updateProjectionMatrix();
      renderer.setSize(w, h, true);
    }
  }
  (function loop(){
    requestAnimationFrame(loop);
    resizeIfNeeded();
    controls.update();
    renderer.render(scene, camera);
  })();
}
